'use client';

import {
  GeneralError as GeneralErrorTemplate,
  type GeneralErrorProps
} from '@coolblue-development/next-error/client';
import {
  CoolblueLogo,
  Header,
  HeaderLogoContainer,
  LogoLink
} from '@coolblue-development/next-header/client';

export default function Error(props: GeneralErrorProps) {
  return (
    <>
      <Header>
        <LogoLink link='/'>
          <HeaderLogoContainer>
            <CoolblueLogo />
          </HeaderLogoContainer>
        </LogoLink>
      </Header>
      <GeneralErrorTemplate {...props} />
    </>
  );
}
